export const uniqueByUuid = <T extends { uuid: string }>(array: T[]): T[] => {
  const seenUuids = new Set<string>();
  return array.filter((profile) => {
    if (!seenUuids.has(profile.uuid)) {
      seenUuids.add(profile.uuid);
      return true;
    }
    return false;
  });
};

export const uniqueByProfileUuid = <T extends { profileUuid: string }>(array: T[]): T[] => {
  const seen = new Set<string>();
  return array.filter((m) => {
    if (seen.has(m.profileUuid)) return false;
    seen.add(m.profileUuid);
    return true;
  });
};

export function onlyUnique<T>(value: T, index: number, self: T[]) {
  return self.indexOf(value) === index;
}
